import {
  CREATE_MONTHLY_SOLAR_REPORT,
  DELETE_MONTHLY_SOLAR_REPORT,
  EDIT_MONTHLY_SOLAR_REPORT,
  RECEIVE_MONTHLY_SOLAR_REPORTS,
  REQUEST_MONTHLY_SOLAR_REPORT,
} from '@sophocles/entities/MonthlySolarReport/monthlySolarReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_MONTHLY_SOLAR_REPORTS: // Read
      return state.merge(action.monthlySolarReports);
    case DELETE_MONTHLY_SOLAR_REPORT: // Delete
      return state.delete(action.monthlySolarReport.toString());
    case EDIT_MONTHLY_SOLAR_REPORT: // Update
    case CREATE_MONTHLY_SOLAR_REPORT: // Create
    case REQUEST_MONTHLY_SOLAR_REPORT:
    default:
      return state;
  }
}

export function monthlySolarReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_MONTHLY_SOLAR_REPORT:
    case DELETE_MONTHLY_SOLAR_REPORT:
    case RECEIVE_MONTHLY_SOLAR_REPORTS:
    case EDIT_MONTHLY_SOLAR_REPORT:
    case REQUEST_MONTHLY_SOLAR_REPORT:
      return getState(state, action);
    default:
      return state;
  }
}
